<template>
  <div id="dps-app">

    <div class="dps-wrapper">

      <div class="dps-content">

        <div class="dp-grid">

          <group-item v-for="group in groups" :group="group" :key="group.id">
          </group-item>

        </div>

      </div>

      <div class="dps-sidebar">

        <p>Välj önskade format nedan</p>

        <div class="dps-header"><img class="dps-icon" width="25" src="./assets/desktop.svg" alt="desktop"> Desktop</div>

        <div class="dps-list">
          <product-item :key="product.id" :onSelectFormat="setFormat" :product="product" v-for="product in desktopProducts">
          </product-item>
        </div>

        <div class="dps-header"><img class="dps-icon" width="25" src="./assets/mobile.svg" alt="mobile"> Mobile</div>

        <div class="dps-list">
          <product-item :key="product.id" :onSelectFormat="setFormat" :product="product" v-for="product in mobileProducts">
          </product-item>
        </div>

        <div class="dps-header">Summering</div>

        <div class="dps-summary">
          <strong><img class="dps-icon" width="21" src="./assets/desktop.svg" alt="desktop"> visningar:</strong>
          <animated-number :value="totalDesktopImpressions"></animated-number>
        </div>

        <div class="dps-summary">
          <strong><img class="dps-icon" width="21" src="./assets/mobile.svg" alt="mobile"> visningar:</strong>
          <animated-number :value="totalMobileImpressions"></animated-number>
        </div>

        <div class="dps-list">
          <div class="dps-item" :key="product.id" v-for="product in selectedProducts">
            {{ productTitle(product) }} ({{product.selectedFormat.size}})
            <br />
            <strong>
              Pris:
              <animated-number
                :value="totalPriceForProduct(product)">
              </animated-number> kr
            </strong>
            <hr />
          </div>
        </div>

        <div v-if="inhouse" class="dps-rebate">
          <input v-model.number="rebate" placeholder="Rabatt i %" type="number">
        </div>

        <br />

        <button
          class="dps-button"
          v-on:click="showPdf"
          v-bind:disabled="!isValidPost">
        Prisinfo och pdf-fil
        </button>

      </div>

    </div>

  </div>
</template>

<script>

import AnimatedNumber from './components/AnimatedNumber.vue'
import ProductItem from './components/ProductItem.vue'
import GroupItem from './components/GroupItem.vue'
import Vue from 'vue'

export default {
  name: 'app',
  components: { AnimatedNumber, ProductItem, GroupItem },

  data () {
    return { impressions: 0, rebate: null }
  },

  computed: {

    inhouse: function () {
      return process.env.DP_ENV !== 'public'
    },

    isValidPost: function() {
      return (this.selectedProducts.length > 0 && this.selectedMedia.length > 0)
    },

    desktopProducts: function() {
      return this.products.filter(function (product) {
        return product.device === 'desktop'
      })
    },

    mobileProducts: function() {
      return this.products.filter(function (product) {
        return product.device === 'mobile'
      })
    },

    groups: function() {
      return this.$store.state.groups
    },

    media: function() {
      return this.$store.state.media
    },

    products: function() {
      return this.$store.state.products
    },

    selectedProducts() {
      return this.$store.getters.selectedProducts
    },

    selectedMedia: function () {
      return this.$store.getters.selectedMedia
    },

    totalMobileImpressions: function () {
      return this.selectedMedia.map((x) => x.mob_imp || 0).reduce(function (mem, value) {
        return mem + value
      }, 0)
    },

    totalDesktopImpressions: function () {
      return this.selectedMedia.map((x) => x.dtp_imp || 0).reduce(function (mem, value) {
        return mem + value
      }, 0)
    },

    totalImpressions: function () {
      return(this.totalMobileImpressions + this.totalDesktopImpressions)
    },

  },

  methods: {

    setFormat(product, format) {
      product.selectedFormat = format
    },

    selectMedium(medium) {
      if (medium.aggregated && medium.selected) {
        const media = this.mediaForGroupId(medium.group)
        media.forEach(medium => {
          if (!medium.aggregated) {
            Vue.set(medium, 'disabled', true)
          }
        })
      }
    },

    totalPriceForProduct: function(product) {
      const cpm = product.selectedFormat.price
      if(product.device === 'desktop')
        return this.totalDesktopImpressions*(cpm/1000)
      else {
        return this.totalMobileImpressions*(cpm/1000)
      }
    },

    mediaForGroupId: function (groupName) {
      return this.media.filter(function (medium) {
        return medium.group.toLowerCase() === groupName.toLowerCase()
      })
    },

    productClass: function (id) {
      let value = ['ad']
      value.push('ad-' + id)
      return value.join(' ')
    },

    productTitle(product) {
      if(product.device === 'desktop') {
        return product.name
      } else {
        return ['Mobil', product.name].join(' ')
      }
    },

    selectedMaps () {
      return this.selectedMedia.map(media => {
        return media.map
      }).filter(function (x, i, a) {
        return a.indexOf(x) == i;
      });
    },

    // TODO: Replace with http://cryptojs.altervista.org/encoding/Base64.html#.WoK3eJPwZE4
    // if we need support for IE 9
    b64EncodeUnicode(str) {
      return window.btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function(match, p1) {
        return String.fromCharCode(parseInt(p1, 16))
      }))
    },

    showPdf(event) {

      // Serialize media
      const media = this.$store.getters.selectedMedia.map(media => {
       return({ name: media.name, impressions: {
         desktop: media.dtp_imp || 0, mobile: media.mob_imp || 0
       }})
      })

      // Serialize products
      const products = this.$store.getters.selectedProducts.map(product => {
        return({
          device: product.device,
          name: product.name,
          size: product.selectedFormat.size,
          cpm: product.selectedFormat.price
        })
      })

      const payload = {
        regions: this.$store.getters.affectedRegions,
        products: products,
        media: media,
        rebate: this.rebate,
        maps: this.selectedMaps()
      }

      const base64String = this.b64EncodeUnicode(JSON.stringify(payload))
      window.location = "https://dp-dig-spinner.herokuapp.com/generate?data=" + base64String

    }

  }

}
</script>

<style>

#dps-app {
  color: #2c3e50;
  max-width: 960px;
  margin: 0 auto;
}

#dps-app ul {
  padding: 0;
  margin: 0;
  list-style: none;
}

.dps-icon {
  vertical-align: middle;
}

.dps-button {
  height: 38px;
  padding: 0 30px;
  text-align: center;
  font-weight: 600;
  line-height: 38px;
  letter-spacing: .1rem;
  text-transform: uppercase;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border-radius: 30px;
  border: none;
  cursor: pointer;
  color: #FFF;
  background-color: #085387;
  display: inline-block;
  font-size: 12px;
}

.dps-button:disabled {
  background: #dadada;
  cursor: not-allowed;
  color: #7b7a7a;
}

.dps-item {
  margin-top: 10px;
}

.dps-item:after {
  content: "";
  display: table;
  clear: both;
}

.dps-summary {
  margin-top: 20px;
}

.dps-wrapper {
  display: flex;
}

.dps-content {
  width: 80%;
}

.dps-sidebar {
  width: 20%;
}

.dp-grid {
  display: flex;
  flex-wrap: wrap;
  padding-right: 20px;
}

.dps-active {
  color: tomato;
}

.dps-highlight {

}

.dps-disabled {
  color: #bfbfbf;
}

.dps-header {
  font-weight: bold;
  margin: 10px 0;
}

.dps-rebate {
  margin-top: 20px;
}

.dps-rebate > input {
  padding: 4px;
  border-radius: 2px;
  border: 1px solid tomato;
  outline: none;
  height: 15px;
  width: 100%;
  font-size: 12px;
}

</style>



// WEBPACK FOOTER //
// src/App.vue